import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalConstants } from 'src/app/constant/constant';
import { TimePickerModalComponent } from '../time-picker-modal/time-picker-modal.component';
import { DateTimeHelper } from 'src/app/utils/date-time-helper';
const dayjs = require('dayjs');
const objectSupport = require('dayjs/plugin/objectSupport');
dayjs.extend(objectSupport);

@Component({
  selector: 'time-picker',
  templateUrl: './time-picker.component.html',
})
export class TimePickerComponent implements OnInit, OnChanges {
  @Input() autoSelectTime = true;
  @Input() minTime; //= '02:30'
  @Input() maxTime; // = '15:30'
  @Input() minInterval; // = '15:30'
  @Input() selectedDateTime;
  @Input() defaultDate = dayjs().format('YYYY-MM-DD');
  @Input() timeZoneId = dayjs.tz.guess();
  @Input() allowMidnight = false;
  @Input() midnightSelected = false;
  @Input() disabled = false;
  @Output() onTimeSelect = new EventEmitter();
  selectedTime24Hour;
  selectedTime;
  values = {
    minHour: 0,
    maxHour: 0,
    minMinute: 0,
    maxMinute: 0,
    minTimeMeridien: 'AM',
    maxTimeMeridien: 'PM',
    selectedHour: 0,
    selectedMinute: 0,
    selectedMeridien: 'AM',
    minInterval: 15,
    midnightSelected: this.midnightSelected,
    allowMidnight: this.allowMidnight,
  };
  constructor(private modalControler: ModalController) {}

  ngOnInit() {
    if (!this.defaultDate) {
      this.defaultDate = dayjs().format('YYYY-MM-DD');
    }

    const timeRoundTo = GlobalConstants.TIME_ROUND_TO_MINUTES;
    if (this.selectedDateTime) {
      this.selectedTime = dayjs(this.selectedDateTime).format('hh:mm A');
    } else if (this.autoSelectTime) {
      const dateNow = Math.round(dayjs().tz(this.timeZoneId).toDate().getTime() / (timeRoundTo * GlobalConstants.ONE_MINUTE_MS)) * (timeRoundTo * GlobalConstants.ONE_MINUTE_MS);
      this.selectedTime = dayjs(dateNow).format('hh:mm A');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedDateTime) {
      this.selectedTime = this.selectedDateTime ? dayjs(this.selectedDateTime).format('hh:mm A') : null;
    }
  }

  openTimePicker = async () => {
    if (!this.disabled) {
      this.values = {
        minHour: +this.minTime.split(':')[0],
        maxHour: +this.maxTime.split(':')[0],
        minTimeMeridien: +this.minTime.split(':')[0] >= 12 ? 'PM' : 'AM',
        maxTimeMeridien: +this.maxTime.split(':')[0] >= 12 ? 'PM' : 'AM',
        minMinute: +this.minTime.split(':')[1].substr(0, 2),
        maxMinute: +this.maxTime.split(':')[1].substr(0, 2),
        selectedHour: this.selectedDateTime ? +this.selectedTime.split(':')[0] : 0,
        selectedMinute: this.selectedDateTime ? +this.selectedTime.split(':')[1].split(' ')[0] : 0,
        selectedMeridien: this.selectedDateTime ? this.selectedTime.split(':')[1].split(' ')[1] : 'AM',
        minInterval: this.minInterval,
        midnightSelected: this.midnightSelected,
        allowMidnight: this.allowMidnight,
      };

      const modal = await this.modalControler.create({
        component: TimePickerModalComponent,
        cssClass: 'timer-picker-modal',
        componentProps: this.values,
        breakpoints: [0,1],
        initialBreakpoint: 1,
        canDismiss: async (data, role) =>
            role === 'cancel' || role === 'done',
        handle: false
      });
      modal.present();

      modal.onDidDismiss().then(({ data }: any) => {
        if (data && 'hour' in data && 'minute' in data && 'meridien' in data) {
          let date = null;

          let selectedDate = this.selectedDateTime ? dayjs(this.selectedDateTime) : dayjs(this.defaultDate);

          if (!this.midnightSelected && data.midnightSelected) {
            date = DateTimeHelper.getStartOfDay(DateTimeHelper.addTime(selectedDate, 1, 'day'));
          } else if (this.midnightSelected && data.midnightSelected) {
            date = DateTimeHelper.getStartOfDay(selectedDate);
          } else if (data.meridien === 'AM' || (data.hour === 12 && data.meridien === 'PM')) {
            if (this.midnightSelected && !data.midnightSelected) {
              selectedDate = DateTimeHelper.addTime(selectedDate, -1, 'day');
            }
            date = selectedDate.tz(this.timeZoneId).hour(data.hour).minute(data.minute);
          } else {
            if (this.midnightSelected && !data.midnightSelected) {
              selectedDate = DateTimeHelper.addTime(selectedDate, -1, 'day');
            }
            date = selectedDate
              .tz(this.timeZoneId)
              .hour(data.hour + 12)
              .minute(data.minute);
          }
          this.midnightSelected = data.midnightSelected;
          this.selectedTime = dayjs(date).format('hh:mm A');
          this.onTimeSelect.emit(dayjs(date).format('YYYY-MM-DDTHH:mm:00'));
        }
      });
    }
  };
}
